import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './routes/App';
import RyanContact from './routes/RyanContact';
import reportWebVitals from './reportWebVitals';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import Restaurants from './routes/Restaurants';
import AmyContact from './routes/AmyContact';
import BrettContact from './routes/BrettContact';
import SquareBeauty from './routes/SquareBeauty';

const router = createBrowserRouter([
  {
    path: '/',
    element: <App />,
  },
  {
    path: '/doordash',
    element: <Restaurants />,
  },
  {
    path: '/contact/ryan',
    element: <RyanContact />,
  },
  {
    path: '/contact/amy',
    element: <AmyContact />,
  },
  {
    path: '/contact/brett',
    element: <BrettContact />,
  },
  {
    path: '/square/beauty',
    element: <SquareBeauty />,
  },
]);
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
